import { render, staticRenderFns } from "./opciones-terminales-listado.vue?vue&type=template&id=fa5acc1e&"
import script from "./opciones-terminales-listado.component.ts?vue&type=script&lang=ts&"
export * from "./opciones-terminales-listado.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports